export default __webpack_public_path__ + "static/media/group-yoga.f917311a.jpg";